import { Icon } from "~/components/ui/icon"
const styles = {
  icon: "w-5 h-5 text-white",
  small: "bg-[#16437c] p-1",
  p: "text-gray-600",
}
const ContactInfo = () => {
  return (
    <div className="space-y-8 ">
      <div className="flex justify-start pl-10 space-x-4">
        <img
          src="/assets/utb-icon.webp"
          alt="UTB Support"
          className="h-16 w-16 object-contain"
        />
      </div>

      <h2 className="text-xl font-semibold pl-10 text-blue-900">
        UTB Trader & Trade Support
      </h2>

      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <small className={styles.small}><Icon name="bx:bxs-map" className={styles.icon} /></small>
          <a href="https://google.com/maps/dir//Melik%C5%9Fah,+%C5%9Eahbaz+Sk.+No:13+D:a,+42090+Meram%2FKonya/@37.86839,32.464278,851m/data=!3m1!1e3!4m9!4m8!1m0!1m5!1m1!1s0x14d084340650e6fd:0x982a2259ad0fd121!2m2!1d32.4639137!2d37.8684064!3e0?entry=ttu&g_ep=EgoyMDI0MTIwMS4xIKXMDSoASAFQAw%3D%3D" target="_blank" className={styles.p} rel="noreferrer">
            Akabe Mah. Saçlı Kasap Cd. A Blok 2.Giriş<br />No:157 AA İç Kapı No:507 <br />Karatay / KONYA / TÜRKİYE
          </a>
        </div>

        <div className="space-y-2">
          <div className="flex items-center space-x-3">
            <small className={styles.small}><Icon name="ic:sharp-call" className={styles.icon} /></small>
            <a href="tel:+905387294137" className={styles.p}>
              +90 538 729 41 37

            </a>
          </div>
          {/* <div className="flex items-center space-x-3">
            <small className={styles.small}><Icon name="ic:round-print" className={styles.icon} /></small>
            <a href="tel:+903322677777" className={styles.p}>
              +90 332 627 77 77
            </a>
          </div> */}
          <div className="flex items-center space-x-3">
            <small className={styles.small}><Icon name="circum:mobile-4" className={styles.icon} /></small>
            <a href="tel:+905368441020" className={styles.p}>
              +90 536 844 10 20
            </a>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <small className={styles.small}><Icon name="f7:envelope-fill" className={styles.icon} /></small>
          <a href="mailto:info@utbsupport.com" className={styles.p}>
            info@utbsupport.com
          </a>
        </div>
      </div>
    </div>
  )
}

export default ContactInfo